import "./tabs.scss";

import {
  Button,
  Card,
  CardBody,
  Col,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";
import React, { useEffect, useState } from "react";
import {
  notificationStrings,
  openNotificationWithIcon,
} from "../../../../common/notification-message/notification";
import { DatePicker } from "antd";
import Loading from "../../../loader/loader";
import DeleteUser from "../../../settings/deleteUser";
import NkTable from "../../nktable";
import {
  getTabC3BeneficiaryList,
  deleteUser,
} from "../../../../service/profile-ras-service";
import moment from "moment";

const C3beneficiarytab = ({ userId }) => {
  const [searchBy, setSearchBy] = useState("receiver");
  const [searchByValue, setSearchByValue] = useState("");

  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState();
  const [dataLoading, setDataLoading] = useState(false);

  const [rakTab, setRakTab] = useState([]);
  const [sizeShow, setSizeShow] = useState();
  const [beneficiaryid, setBeneficiaryid] = useState("");
  const [buttonloading, setButtonloading] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const request = {
    page: 1,
    size: 10,
    beneficiaryName: "",
    sender: "",
    fromDate: "",
    toDate: "",
    searchType: "",
    searchCountry: "",
    searchStatus: "",
    c3REF: "",
    rakRef: "",
    referralCode: "",
    profileStatus: "",
    beneficiaryMobile: "",
  };
  const [filterForm, setFilterForm] = useState(request);
  const [pagination, setPagination] = useState({
    pageSize: 10,
    total: 0,
    current: 1,
  });

  const columns = [
    {
      dataField: "registrationDate",
      text: "Date",
      sort: true,
      style: { minWidth: "100px", textAlign: "Left" },
      formatter: (cell, row) => {
        return moment((row && row.registrationDate) || null).format(
          "DD-MM-YY  HH:mm:ss"
        );
      },
    },
    {
      dataField: "beneficiary",
      text: "Beneficiary",
      sort: false,
      style: { minWidth: "100px", textAlign: "left" },
    },

    {
      dataField: "beneficiaryPhoneNumber",
      text: "Receiver",
      sort: false,
      style: { minWidth: "100px", textAlign: "center" },
      headerStyle: { textAlign: "center" },
    },

    {
      dataField: "appStatus",
      text: "Registered on app",
      sort: false,
      headerStyle: { textAlign: "center" },
      style: { minWidth: "150px", textAlign: "center" },
    },
    {
      dataField: "actions",
      text: "Action",
      sort: false,
      headerStyle: { textAlign: "center" },
      style: { minWidth: "150px", textAlign: "center" },
      formatter: (cell, row) => {
        return (
          <i
            className="fas fa-trash-alt"
            style={{ cursor: "pointer", textAlign: "center" }}
            onClick={() => {
              if (row && row.id) {
                setBeneficiaryid(row.id);
                setDeleteModal(true);
              }
            }}
          />
        );
      },
    },
  ];

  const [id, setId] = useState();

  useEffect(() => {
    if (userId) {
      setId(userId);
    }
  }, []);

  useEffect(() => {
    if (id) {
      getC3beneficiaryList(filterForm, id);
    }
  }, [id]);

  useEffect(() => {
    if (filterForm && filterForm.isFilter) {
      getC3beneficiaryList(filterForm, id);
    }
  }, [filterForm]);

  const getC3beneficiaryList = (request, id) => {
    request.size = sizeShow || 10;
    setDataLoading(true);
    getTabC3BeneficiaryList(request, id)
      .then((res) => {
        setDataLoading(false);
        setRakTab(res.data.moneyTransferBeneficiaries || []);
        setPagination({
          ...pagination,
          pageSize: sizeShow || 10,
          total: res.data.totalCount,
          current: request.page,
        });
      })
      .catch((err) => {
        setDataLoading(false);
        console.log(err);
        setRakTab([]); // TODO -NEED TO REMOVE
      });
  };

  const handleFilter = () => {
    let request = {};

    if (searchBy === "receiver") {
      request = {
        ...filterForm,
        beneficiaryName: null,
        beneficiaryMobile: searchByValue,
      };
    } else if (searchBy === "beneficiary") {
      request = {
        ...filterForm,
        beneficiaryName: searchByValue,
        beneficiaryMobile: null,
      };
    }

    request.fromDate =
      (fromDate && moment(fromDate).format("YYYY-MM-DD")) || null;
    request.toDate = (toDate && moment(toDate).format("YYYY-MM-DD")) || null;
    request.page = 1;
    request.isFilter = true;
    setFilterForm(request);
  };

  let searchByValuePlaceholder = "";
  if (searchBy === "receiver") {
    searchByValuePlaceholder = "971501234567";
  } else if (searchBy === "beneficiary") {
    searchByValuePlaceholder = "Amit Pandit";
  }
  //Delete APi
  const onDelete = () => {
    setButtonloading(true);
    deleteUser(beneficiaryid)
      .then((res) => {
        setDeleteModal(false);
        setButtonloading(false);
        //message.success("Delete Successfully");
        openNotificationWithIcon(
          notificationStrings.success,
          "Deleted Successfully"
        );
        setBeneficiaryid("");
        getC3beneficiaryList(filterForm, id);
      })
      .catch((err) => {
        setDeleteModal(false);
        setButtonloading(false);
        //openNotificationWithIcon(notificationStrings.error, err);
        // message.error("Something went wrong");
      });
  };

  const resetFilter = () => {
    setSearchBy("receiver");
    request.isFilter = true;
    setFromDate(null);
    setToDate(null);

    setSearchByValue("");

    setRakTab([]);
    setFilterForm(request);
  };
  const dateFormat = "DD-MM-YY";
  const customFormat = (value) => `${value.format(dateFormat)}`;
  console.log("searchBy", searchBy);

  return (
    <>
      <Row
        style={{ marginLeft: "0px", marginRight: "0px", padding: "12px 0px" }}
      >
        <Col lg="2" className="form-input-padding-tab">
          <FormGroup>
            <label
              className="form-control-label"
              htmlFor="exampleFormControlSelect1"
            >
              Search by
            </label>
            <Input
              id="exampleFormControlSelect1"
              style={{ height: "28px" }}
              type="select"
              value={searchBy}
              onChange={(e) => {
                setSearchByValue("");
                setSearchBy(e.target.value);
              }}
            >
              <option value="receiver">Receiver</option>
              <option value="beneficiary">Beneficiary</option>
            </Input>
          </FormGroup>
        </Col>
        <Col lg="2" className="form-input-padding-tab">
          <FormGroup>
            <label className="form-control-label" htmlFor="example3cols2Input">
              Search for
            </label>
            <Input
              id="example3cols2Input"
              placeholder={searchByValuePlaceholder}
              type="text"
              style={{ height: "27px" }}
              onKeyPress={(e) => e.charCode === 13 && handleFilter(true)}
              onChange={(e) =>
                setSearchByValue(
                  e.target && e.target.value && e.target.value.trim()
                )
              }
              value={searchByValue}
            />
          </FormGroup>
        </Col>
        <Col lg="2" className="form-input-padding-tab">
          <FormGroup>
            <Label className="form-control-label" htmlFor="example3cols2Input">
              From
            </Label>
            <DatePicker
              placeholder="DD-MM-YY"
              className="formcontrol-date"
              onChange={(e, dateString) => {
                if (dateString && dateString != "") {
                  setFromDate(moment(dateString, dateFormat));
                } else {
                  setFromDate(null);
                }
              }}
              value={fromDate}
              format={customFormat}
            />
          </FormGroup>
        </Col>
        <Col lg="2" className="form-input-padding-tab">
          <FormGroup>
            <Label className="form-control-label" htmlFor="example3cols2Input">
              To
            </Label>
            <DatePicker
              placeholder="DD-MM-YY"
              className="formcontrol-date"
              onChange={(e, dateString) => {
                if (dateString && dateString != "") {
                  setToDate(moment(dateString, dateFormat));
                } else {
                  setToDate(null);
                }
              }}
              value={toDate}
              format={customFormat}
            />
          </FormGroup>
        </Col>

        <Col
          lg="1"
          style={{ marginTop: "9px" }}
          className="form-input-padding-tab"
        >
          <FormGroup>
            <Label
              className="form-control-label"
              htmlFor="example3cols2Input"
            ></Label>
            <div>
              <Button
                type="button"
                style={{
                  width: "100%",
                  background: "#e91d24",
                  color: "white",
                  height: "26px",
                  border: "1px solid rgb(233, 29, 36)",
                }}
                id="example3cols2Input"
                className="filter-button"
                onClick={() => handleFilter(true)}
              >
                <div>
                  <i class="fas fa-search"></i>
                </div>
              </Button>
            </div>
          </FormGroup>
        </Col>
        <Col
          lg="1"
          style={{ marginTop: "9px" }}
          className="form-input-padding-tab"
        >
          <FormGroup>
            <Label
              className="form-control-label"
              htmlFor="example3cols2Input"
            ></Label>
            <div>
              <Button
                color="light"
                type="button"
                style={{ width: "100%", height: "26px" }}
                id="example3cols2Input"
                className="filter-button"
                onClick={() => resetFilter()}
              >
                <div
                  style={{
                    fontSize: "12px",
                  }}
                >
                  {" "}
                  <i class="fas fa-redo-alt 2px"></i> Reset
                </div>
              </Button>
            </div>
          </FormGroup>
        </Col>
      </Row>
      {rakTab.length < 0 ? (
        <>
          <Card
            className="mb-4"
            style={{
              display: "flex",
              flex: 1,
              textAlign: "center",
              justifyContent: "center",
              padding: "1.25rem 1.5rem",
            }}
          >
            <CardBody>
              <h3 className="mb-0">No Records Found</h3>
            </CardBody>
          </Card>
        </>
      ) : (
        <>
          <Row style={{ padding: "1.25rem 0.5rem" }}>
            <div className="col card-parent">
              <Card>
                {dataLoading ? (
                  <div style={{ textAlign: "center" }}>
                    <Loading />
                  </div>
                ) : (
                  <>
                    <NkTable
                      filename={"All-User-List"}
                      data={rakTab}
                      columns={columns}
                      pagination={pagination}
                      onPagechange={(page) => {
                        setFilterForm({
                          ...filterForm,
                          page: page,
                          isFilter: true,
                        });
                      }}
                      showSizeChanged={(pageSize) => {
                        setSizeShow(pageSize);
                        setFilterForm({
                          ...filterForm,
                          page: pageSize,
                          isFilter: true,
                        });
                      }}
                    />
                  </>
                )}
              </Card>
            </div>
          </Row>
        </>
      )}
      <DeleteUser
        show={deleteModal}
        onHide={() => setDeleteModal(false)}
        onDelete={onDelete}
        deleteLoader={buttonloading}
      />
    </>
  );
};
export default C3beneficiarytab;
